module.exports = __webpack_public_path__ + "static/media/japan.cdb5dc05.svg";